module.exports = __webpack_public_path__ + "static/img/bystage_03.91013ed1.svg";